import React from 'react';
import commonStyle from 'components/common.module.css';
import cx from 'clsx';

import { useTenantId } from 'hooks/useTenantId';

import style from './ContactUs.module.css';

interface Props {
  type: 'LOGIN' | 'SIGN_UP';
}

const ContactUs: React.FC<Props> = ({type}) => {
  const tenantId = useTenantId();
  return (
    <>
      <div className={cx(commonStyle.centerLink, type === 'SIGN_UP' ? style.tinyMargin : style.smallMargin)}>
        {type === 'SIGN_UP' ? 'Having trouble signing up?' : 'Having trouble logging in?'}{' '}
        <a
          className={cx(commonStyle.link, commonStyle.link_blue)}
          target='_blank'
          rel='noreferrer nofollow'
          href={tenantId === 'bstot5' ? 'https://isusteadfast.com/contact-us' : tenantId === 'bl7mcb' ? 'https://www.piib.com/contact-us/' : 'mailto:info@ennabl.com'}
        >
          {tenantId === 'bstot5' ? 'Contact ISU Support' : tenantId === 'bl7mcb' ? 'Contact PIIB Support' : 'Contact Us'}
        </a>
      </div>
      <div className={cx(commonStyle.centerLink, style.tinyMargin)}>
        <a
          className={cx(commonStyle.link, commonStyle.link_grey)}
          target='_blank'
          rel='noreferrer nofollow'
          href={'https://www.notion.so/ennabl/Website-Privacy-Policy-3c00ebf5817e4efa9bc3ea4bcc17c815'}
        >
          Privacy Policy
        </a>
      </div>
    </>
  );
};

export default ContactUs;
